module.exports = __webpack_public_path__ + "img/page1.f65636cf.png";